export const requiredFieldMessage = 'To pole jest wymagane.';
